import React from 'react';

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import {Collections, Objects} from "components";

import {Button} from 'reactstrap';
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Acquisitions',
		url: '/acquisitions',
		icon: 'download',
	},
	{
		name: 'Pawn Dashboard',
		url: '/acquisitions/pawns',
		icon: 'usd',
	}
];

export default class Pawns extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.backdrop = true;
		this.state.modalPawn = false;
		this.state.closeModal = 0;
		this.state.bypass = false;
	}

	handlingToggle = () => {
		if (this.state.backdrop !== 'static'){
			this.setState({modalPawn: !this.state.modalPawn});
		} else {
			if (this.state.closeModal > 0 || this.state.bypass){
				this.setState({closeModal: 0});
				this.setState({backdrop: true});
				this.setState({modalPawn: !this.state.modalPawn});
			} else {
				this.setState({closeModal: 1});
				API.Toast.info('You have unsaved changes. Click again to close modal.', {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 4000
				});
			}
		}
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalPawn')} size="sm" color="primary">
						<i className="fa fa-usd"/>&nbsp;&nbsp;Add Pawn
					</Button>
				</Framework.Components.PageBar>

				<Collections.Pawns
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					locations={this.props.locations}
					states={this.props.states}
				/>

				{/*Don't pass toggle if passing showModal*/}
				<UniversalModalOverride
					showModal={this.state.modalPawn}
					locations={this.props.locations}
					states={this.props.states}
					name={"Acquisition"}
					object={Objects.Acquisition}
					history={this.props.history}
					reportClose={this.reportClose('modalPawn')}
					afterSave={() => {this.setState({bypass: false})}}
					handleToggle={this.handlingToggle}
					size={'xl'}
					objectProps={{
						modalState: this.state['modalPawn'],
						setBackdrop: (backdrop) => this.setState({backdrop}),
						setBypass: (bypass) => this.setState({bypass})
					}}
				/>
			</div>
		);
	}
}